import { useForm } from "react-hook-form";
import { GenericComponent } from "../../components/GenericComponent";
import { InfoAccionista } from "../../models/matriz/InfoAccionista";
import { InfoAccionistaService } from "../../service/matriz/InfoAccionistaService";
import { useEffect, useRef, useState } from "react";
import { InputComponent } from "../../components/InputComponent";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import { DetalleAccionistaDos } from "./DetalleAccionistaDos";
import { Button } from "primereact/button";
import { Generico } from "../../components/Generico";
import { Busqueda } from "./Busqueda";
import { useToken } from "../../components/useToken";
import { PlantillaColor } from "./PlantillaColor";
import { TablaDinamica } from "../../components/TablaDinamica";
import { useLazyParams } from "../../hooks/useLazyParams";
import { Column } from "primereact/column";
import { Menu } from "primereact/menu";

export const PerfilEmpleado = () => {
    const [siEmpresa, setSiEmpresa] = useState(true);
    const [catalogo, setCatalogo] = useState(null);
    const omodel = new InfoAccionista({ formularioMatriz: catalogo?.formularioMatriz, siEmpresa });
    const generic = new GenericComponent();
    const accionistaSrv = new InfoAccionistaService();
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue } = useForm({ defaultValues });    
    const [permss, setPermss] = useState(null);
    const { getRol } = useToken();
    const toast = useRef(null);
    const { funcMessageBlobError, downloadPdf, limpiarNombre } = Generico();
    const [dialogEmpleado, setDialogEmpleado] = useState(false);
    const [dialogPerfil, setDialogPerfil] = useState(false);
    const [dialogColor, setDialogColor] = useState(false);
    const [matriz, setMatriz] = useState(null);
    const [dialogBusqueda, setDialogBusqueda] = useState(false);
    const [opcion, setOpcion] = useState(null);
    const [siFormulario, setSiFormulario] = useState(false);
    const { inDrop, inText, inCalendar } = InputComponent({ omodel, generic, errors, control, permss, id: getValues('id') });
    const tablaEstado = useLazyParams({ modelo: omodel.model });
    const menuRef = useRef(null);

    useEffect(() => {
        loadLazyData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tablaEstado.lazyParams]);

    const loadLazyData = () => {
        tablaEstado.setLoading(true);
        let _lazyParams = { ...tablaEstado.lazyParams };
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = 'permiso';
        }
        if (getRol()) {
            _lazyParams.rol = getRol();
        }
        accionistaSrv.lista({ lazyEvent: JSON.stringify(_lazyParams) }, 'e').then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);
            if (catalogo == null) {
                setCatalogo(res.data.catalogos);
                const _perms = res.data.perss;
                _perms.b1t = "Editar información inicial de matrices";
                _perms.b2t = "Editar / registrar detalles de información de matrices";
                _perms.b3t = "Eliminar información inicial de matrices";
                setPermss(res.data.perss);
                setOpcion(res.data.opcion);
                setSiEmpresa(res.data.opcion === 'PRELAFIT' || res.data.opcion.includes('RIESGO_CLIENTE-LISTA-EMPRESA'));
            }
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    }

    const edit = () => {
        accionistaSrv.consultar(matriz?.id, 'e').then(res => {
            values(res.data);
        });
    }

    const onSubmit = (data) => {
        data.fecha = generic.dateToString(data.fecha);
        data.fecha_nacimiento = generic.dateToString(data.fecha_nacimiento);
        if (getValues('id') == null) {
            accionistaSrv.nuevo(data, 'e').then(res => {
                generic.funcSuccess(res, toast);
                setDialogEmpleado(false);
                tablaEstado.refreshData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        } else {
            accionistaSrv.editar(data, 'e').then(res => {
                generic.funcSuccess(res, toast);
                tablaEstado.refreshData();
                setDialogEmpleado(false);
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
    }

    const values = (_empleado) => {
        setSiFormulario((typeof _empleado?.idp === 'number') || typeof matriz?.idp === 'number');
        const lista = { tipo_identificacion: catalogo?.tipo_identificacion, };
        if (siOpcion('RIESGO_EMPLEADO-LISTA-EMPRESA', permss?.actualizar)) {
            lista.empresa = catalogo?.empresas;
        } else {
            delete _empleado?.empresa;
        }

        Object.keys(lista).forEach(function (key) {
            if (_empleado[key] != null) {
                lista[key].forEach(element => {
                    if (element.cat_id === _empleado[key]) {
                        _empleado[key] = element;
                    }
                });
            }
        });
        _empleado.fecha = generic.stringToDate(_empleado.fecha);
        _empleado.fecha_nacimiento = generic.stringToDate(_empleado.fecha_nacimiento);

        reset(generic.renewValues(_empleado, omodel.model));
        setDialogEmpleado(true);
    }

    const volverBorradorItem = (num, op) => {
        confirmDialog({
            message: `¿Está seguro de volver el análisis a ${num} año${num > 1 ? 's' : ''} a borrador?`,
            header: 'Confirmar',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-warning',
            acceptLabel: 'Sí',
            rejectLabel: 'No',
            accept: () => {
                accionistaSrv.volverBorrador({ id: matriz.id }, num, op).then(res => {
                    generic.funcSuccess(res, toast);
                    tablaEstado.refreshData();
                }).catch(error => {
                    generic.funcDeleteError(error, toast);
                });
            }
        });
    };

    const deleteItem = () => {
        confirmDialog({
            message: '¿Esta seguro de eliminar la matriz?',
            header: 'Confirmar',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Si',
            rejectLabel: 'No',
            accept: () => {
                accionistaSrv.eliminar(matriz?.id, 'e').then(res => {
                    generic.funcSuccess(res, toast);
                    tablaEstado.refreshData();
                }).catch(error => {
                    generic.funcDeleteError(error, toast);
                });
            }
        });
    }

    const calcularEdad = (data) => {
        let today = new Date();
        let age = today.getFullYear() - data.getFullYear();
        let m = today.getMonth() - data.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < data.getDate())) {
            age--;
        }
        setValue('edad', age);
    }

    const openNew = () => {
        setSiFormulario(false);
        reset(defaultValues);
        setDialogEmpleado(true);
    }

    const generarReporte = (numero) => {
        tablaEstado.setLoading(true);
        const nombreArchivo = `Matriz Empleado - ${limpiarNombre(matriz.nombres)}.pdf`;
        accionistaSrv.descargar(matriz?.id, numero, 'e').then(res => {
            downloadPdf(res, nombreArchivo);
        }).catch(error => {
            funcMessageBlobError('Asegúrese de ingresar la información antes de generar el reporte.', error, toast);
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar && matriz?.estado_final !== 'FINALIZADO')
            items.push({ label: 'Editar información de inicio', icon: 'pi pi-pencil', command: () => { edit() } });
        if (permss?.actualizar && matriz?.estado_final !== 'FINALIZADO')
            items.push({ label: 'Contenido de la matriz', icon: 'pi pi-qrcode', command: () => { setDialogPerfil(true) } });
        if (permss?.consultar && matriz?.nemonico === 'FINALIZADO')
            items.push({ label: 'Imprimir matriz Análisis a Dos años a PDF', icon: 'pi pi-print', command: () => { generarReporte(4) } });
        if (permss?.consultar && matriz?.estado_uno === 'FINALIZADO')
            items.push({ label: 'Imprimir matriz Análisis a Un año a PDF', icon: 'pi pi-print', command: () => { generarReporte(5) } });
        if (permss?.eliminar && matriz?.estado_uno === null && matriz?.nemonico === null)
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { deleteItem() } });
        if (permss?.actualizar && matriz?.nemonico === 'FINALIZADO' && siOpcion('RIESGO_EMPLEADO-VOLVER-BORRADOR', permss?.actualizar)) {
            items.push({ label: 'A borrador (2 años)', icon: 'pi pi-history', command: () => { volverBorradorItem(2, 'n') } });
        }
        if (permss?.actualizar && matriz?.estado_uno === 'FINALIZADO' && siOpcion('RIESGO_EMPLEADO-VOLVER-BORRADOR', permss?.actualizar)) {
            items.push({ label: 'A borrador (1 año)', icon: 'pi pi-history', command: () => { volverBorradorItem(1, 'n') } });
        }

        return [{ label: 'Opciones', items: items }];
    }

    const siOpcion = (strOpcion, crud) => {
        return crud && (opcion === 'PRELAFIT' || opcion.includes(strOpcion));
    }

    const startContent = (
        <>
            {permss?.crear && <Button icon="pi pi-plus" className="mr-2" tooltip="Nueva matriz" onClick={openNew} />}
            {siOpcion('RIESGO_EMPLEADO-BUSCAR-BVG', permss?.actualizar) && <Button icon="pi pi-search" className="mr-2" tooltip="Búsqueda Funcionarios y Colaboradores" onClick={() => setDialogBusqueda(true)} />}
            {siOpcion('RIESGO_EMPLEADO-COLORES', permss?.actualizar) && <Button icon="pi pi-palette" className="mr-2" tooltip="Configuración de colores" onClick={() => setDialogColor(true)} />}
        </>
    );

    const seleccionar = (data) => {
        values({
            fecha: data?.fecha,
            tipo_identificacion: data?.tipo_identificacion,
            identificacion: data?.identificacion,
            nombres: data?.razon_social,
            fecha_nacimiento: data?.fecha_nacimiento,
            edad: data?.edad,
            cargo: data?.cargo,
            idp: data?.id
        });
        setDialogBusqueda(false);
    }

    const regresar = () => {
        setMatriz(null);
        setDialogPerfil(true);
        setDialogPerfil(false);
        tablaEstado.refreshData();
    }

    const accionesTemplate = (rowData) => {
        return (
            <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu" aria-haspopup
                onClick={(event) => { setMatriz(rowData); menuRef.current.toggle(event); }} />
        );
    };

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '6rem', textAlign: 'center' }} />
    );

    return (
        <>
            <ConfirmDialog />
            <Toast ref={toast} />
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu" />
            {!dialogPerfil && <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                <Toolbar className="mb-4" start={startContent}
                    end={generic.rightToolbarTemplate(tablaEstado.data, omodel, 'Listado_matrices', 'LISTADO MATRICES')}></Toolbar>
                <TablaDinamica modelo={omodel.model} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="id" acciones={ColumnaAcciones} />
            </Card>}

            <Dialog visible={dialogEmpleado} header={getValues('id') == null ? "Nueva matriz" : "Editar matriz"} modal className="p-fluid modal-ssize"
                onHide={e => setDialogEmpleado(false)} style={{ maxWidth: '500px' }}>
                <br />
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {inCalendar('fecha', { disabled: siFormulario }, 12)}
                        {inDrop('tipo_identificacion', catalogo?.tipo_identificacion, { lab: omodel.optionLabel, ne: siFormulario }, 6)}
                        {inText('identificacion', { readOnly: siFormulario ? 'readOnly' : '' }, 6)}
                        {inText('nombres', { readOnly: siFormulario ? 'readOnly' : '' }, 12)}
                        {inCalendar('fecha_nacimiento', { onChange: calcularEdad }, 6)}
                        {inText('edad', { readOnly: 'readOnly' }, 6)}
                        {inText('cargo', { readOnly: siFormulario ? 'readOnly' : '' }, 6)}
                        {siOpcion('RIESGO_EMPLEADO-LISTA-EMPRESA', permss?.actualizar) &&
                            inDrop('empresa', catalogo?.empresas, { lab: omodel.optionLabel, col: 6 }, 6)}
                    </div>

                    {generic.buttonsForms(setDialogEmpleado)}
                </form>
            </Dialog>
            {dialogPerfil && <DetalleAccionistaDos matrizId={matriz?.id} permss={permss} setDialogPerfil={setDialogPerfil} toast={toast} perfil="e" numero="4" uno="5"
                regresar={regresar} funcionalidades={opcion} />}

            <Dialog visible={dialogBusqueda} header='BÚSQUEDA - FUNCIONARIOS Y COLABORADORES' modal className="p-fluid modal-ssize"
                onHide={e => setDialogBusqueda(false)} style={{ maxWidth: '900px' }}>
                <Busqueda opcion="funcionario-matriz" permss={permss} toast={toast} seleccion={seleccionar} filtro={catalogo?.filtroMatriz} />
            </Dialog>

            <Dialog visible={dialogColor} header="Colores" modal className="p-fluid modal-ssize dialog-personalizado"
                onHide={e => setDialogColor(false)} style={{ width: '800px' }}>
                <PlantillaColor generic={generic} permss={permss} toast={toast} catalogo={catalogo} funcionalidades={opcion} tipo={"RIESGO_EMPLEADO"} />
            </Dialog>
        </>
    )
}
